import React from 'react';
import { useHistory } from 'react-router-dom';
import { currentUser, selectScreenSize } from 'redux/session/selectors';
import { selectCurrentTeamName } from 'redux/team/selectors';
import { useSelector } from 'react-redux';
import {
  Switcher,
  SwitcherItem,
  SwitcherDivider
} from 'carbon-components-react';
import { APP_URL, OTHER_URL, TEAM_NAME, SCREEN_SIZE } from 'types';

const UserMenu: React.FC<Props> = ({ onOpenpanel, disableNav }) => {
  const user = useSelector(currentUser);
  const temaName = useSelector(selectCurrentTeamName);
  const screenSize = useSelector(selectScreenSize);
  const history = useHistory();

  return (
    <>
      <div className="panel-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">User menu</div>
      </div>
      <div className="user-menu-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">
          Signed in as {user?.first_name} {user?.last_name}{' '}
          {user?.is_trial && '(free plan)'}
        </div>
      </div>
      <Switcher aria-label="Others" className="user-menu-list">
        <SwitcherItem
          aria-disabled={disableNav}
          aria-label="Settings"
          onClick={
            disableNav ? undefined : () => history.push(APP_URL.SETTINGS)
          }
        >
          Settings
        </SwitcherItem>

        <SwitcherItem
          aria-label="Give feedback"
          onClick={() => onOpenpanel('feedback')}
        >
          Give feedback
        </SwitcherItem>

        <SwitcherItem
          aria-label="Help"
          onClick={() => window.open(OTHER_URL.HELP, '_blank')}
        >
          Help
        </SwitcherItem>
        <SwitcherDivider />
        {screenSize && screenSize === SCREEN_SIZE.SM && (
          <>
            <SwitcherItem
              aria-label="Help"
              className="other-panel-item"
              onClick={() => onOpenpanel('notification')}
            >
              Notifications
            </SwitcherItem>
            <SwitcherDivider />
            <SwitcherItem
              aria-label="Team Name"
              className="other-panel-item"
              onClick={() => onOpenpanel('teams')}
            >
              {temaName || TEAM_NAME.PRIVATE}
            </SwitcherItem>
            <SwitcherDivider />
          </>
        )}
        <SwitcherItem
          aria-label="Sign out"
          className="sign-out"
          onClick={() => history.push(APP_URL.LOGOUT)}
        >
          Sign out
        </SwitcherItem>
      </Switcher>
    </>
  );
};

type Props = {
  disableNav?: boolean;
  onOpenpanel: Function;
};

export default React.memo(UserMenu);
